import { useEffect, useCallback } from 'react';
import { useReportViewModeStore } from 'stores/ReportViewModeStore';
import { useReportId } from './helperHooks';

// Match values with ResponsiveGridLayout component
const QUERIES = {
  single: '(max-width: 768px)',
  split: '(max-width: 1282px)',
} as const;

export const useReportViewMode = () => {
  const { viewMode, setViewMode, setShowShelfForSingleViewMode } = useReportViewModeStore();
  const { isCreate } = useReportId();

  const updateViewMode = useCallback(() => {
    if (window.matchMedia(QUERIES.single).matches) {
      setViewMode('single');
    } else if (window.matchMedia(QUERIES.split).matches) {
      setViewMode('split');
    } else {
      setViewMode('full');
    }
  }, [setViewMode]);

  useEffect(() => {
    const singleMedia = window.matchMedia(QUERIES.single);
    const splitMedia = window.matchMedia(QUERIES.split);

    updateViewMode();

    singleMedia.addEventListener('change', updateViewMode);
    splitMedia.addEventListener('change', updateViewMode);

    return () => {
      singleMedia.removeEventListener('change', updateViewMode);
      splitMedia.removeEventListener('change', updateViewMode);
    };
  }, [updateViewMode]);

  useEffect(() => {
    if (viewMode === 'single') {
      setShowShelfForSingleViewMode(isCreate);
    }
  }, [viewMode, isCreate]);
};
